import { Box, Grid } from "@mui/material";
import React from "react";
import crash_for_cars_logo from "../../assets/png/cash_for_cars_logo.png";
import crashed_toys_logo from "../../assets/png/crashed_toys_logo.png";
import npa_logo from "../../assets/png/npa_logo.png";
import copart_brand_logo from "../../assets/png/copart_brand_logo.png";
import pw_brand_logo_horiz from "../../assets/png/pw_brand_logo_horiz.png";
import { isMobileDeviceCheckByUserAgent } from "../../utils";

export const BrandLogo = () => {
  const isMobile = isMobileDeviceCheckByUserAgent();
  const height = isMobile ? "20px" : "25px";
  const width = isMobile ? "50px" : "100px";
  return (
    <Grid
      width="100%"
      justifyContent="center"
      alignItems="center"
      mb={2}
      mt={{ md: 3 }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-evenly"}
        alignItems={"end"}
        width={"100%"}
      >
        <img
          src={pw_brand_logo_horiz}
          style={{ height: height, width: width }}
        />
        <img src={npa_logo} style={{ height: height, width: width }} />
        <img src={copart_brand_logo} style={{ height: height, width: width }} />
        <img
          src={crash_for_cars_logo}
          style={{ height: height, width: width }}
        />
        <img src={crashed_toys_logo} style={{ height: height, width: width }} />
      </Box>
    </Grid>
  );
};
